<template>
  <van-popup v-model="getGuideToAppPopupInfo.isShow" class="HowToSearchPopup" :close-on-click-overlay="false" @close="close">
    <div class="popupCon">
      <div class="contentBox">
        <div class="modifyBg"></div>
        <div class="content">
          <div class="topPart">
            <div class="icon"></div>
            <div class="title" v-text="getGuideToAppPopupInfo.title"></div>
            <div class="desc" v-text="getGuideToAppPopupInfo.desc"></div>
          </div>
          <div class="btn tapActive" v-text="getGuideToAppPopupInfo.isLinkToApp ? '立即下载' : '我知道了'" @click="btnHandler()"></div>
        </div>
      </div>
      <i class="iconfont icon-guanbi" @click="close"></i>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'GuideToAppPopup',

  data() {
    return {
      show: false
    }
  },

  computed: {
    ...mapGetters(['getGuideToAppPopupInfo'])
  },

  components: {
    'van-popup': Popup
  },

  mounted() {},

  methods: {
    ...mapMutations(['SET_GUIDE_TO_APP_POPUP_INFO']),
    // 关闭
    close() {
      this.SET_GUIDE_TO_APP_POPUP_INFO({
        ...this.getGuideToAppPopupInfo,
        isShow: false
      })
    },
    btnHandler() {
      if (!this.getGuideToAppPopupInfo.isLinkToApp) {
        this.close()
        return
      }
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.soho.sohomm', '_self')
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.HowToSearchPopup {
  background-color: transparent;
  width: 90%;
  overflow-y: visible;
  .popupCon {
    display: flex;
    flex-direction: column;
    align-items: center;
    .iconfont {
      font-size: vw(34);
      color: #ffffff;
      margin-top: vw(30);
    }
  }
  .contentBox {
    position: relative;
    width: vw(271);
    height: vw(368.5);
    margin: 0 auto;
    .content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background: pink;
      background: url('~@/assets/image/icon3.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: vw(50) 0 vw(20);
      box-sizing: border-box;
      // border-radius: vw(10);
      .topPart {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 vw(16);
        box-sizing: border-box;
        .icon {
          width: vw(181);
          height: vw(109);
          background: url('~@/assets/image/icon4.png');
          background-size: 100% 100%;
          margin: 0 0 vw(20);
        }
        .title {
          font-size: vw(20);
        }
        .desc {
          margin-top: vw(12);
        }
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: vw(133);
        height: vw(48);
        border-radius: vw(24);
        background: #000000;
        color: #ffffff;
      }
    }
    .modifyBg {
      position: absolute;
      bottom: 0;
      left: 0;
      content: '';
      width: vw(270);
      height: vw(295);
      background: #979797;
      border-radius: vw(20);
      transform: rotate(10deg);
    }
    .copyKeyWard {
      position: absolute;
      left: 50%;
    }
  }
}
</style>
